<div class="panel-group"><ng-content /></div>
